export const SET_EFFECT_NAME = 'SET_EFFECT_NAME';
export const SET_EFFECT_TYPE = 'SET_EFFECT_TYPE';
export const SET_EFFECT_DAMAGE_DICE = "SET_EFFECT_DAMAGE_DICE";
export const SET_EFFECT_SAVE_DC = "SET_EFFECT_SAVE_DC";
export const SET_EFFECT_SAVE_STAT = "SET_EFFECT_SAVE_STAT";
export const SET_EFFECT_NUM_TURNS = "SET_EFFECT_NUM_TURNS";
export const SET_ALL_EFFECT_TYPES = "SET_ALL_EFFECT_TYPES";
export const SET_EFFECT_CREATION_MESSAGE = "SET_EFFECT_CREATION_MESSAGE"